import React from 'react';
import './Completed.css';

const Completed = () => {
    const handleGoToService = () => {
        window.location.href = 'https://www.thecleanier.com/snack'; // 클리니어 서비스 URL로 이동
    };

    return (
        <div className="completed-page">
            <div className="top">
                <img src="/logo.png" alt="Cleanier Snack" className="complete-logo" />
            </div>
            <div className="completed-container">
                <div className="thank-container">
                    <img src='/finish.png' alt='check' className='check-image' />
                    <div className='message'>
                        클리니어스낵에서 맛있게 보내드릴게요! <br />
                        감사합니다.
                    </div>
                    <button onClick={handleGoToService} className="go-to-service-button">
                        클리니어 서비스 보러가기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Completed;
